import { render, staticRenderFns } from "./cdn-base-input.vue?vue&type=template&id=4031283f&scoped=true&"
import script from "./cdn-base-input.vue?vue&type=script&lang=js&"
export * from "./cdn-base-input.vue?vue&type=script&lang=js&"
import style0 from "./cdn-base-input.vue?vue&type=style&index=0&id=4031283f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031283f",
  null
  
)

export default component.exports